import { DOMAttributes } from 'react';
import styled, { DefaultTheme } from 'styled-components';

export interface HeaderButtonProps extends DOMAttributes<HTMLButtonElement> {
  className?: string;
  color?: keyof DefaultTheme['colors'];
}

const HeaderButton = styled.button`
  border: 0;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  z-index: 1;
  background: none;
  position: relative;

  &:hover,
  &:focus-visible {
    background: rgb(0, 0, 0, 0.1);
  }
`;

export default HeaderButton;
